
































import 'reflect-metadata'
import { Component, Watch, Mixins } from 'vue-property-decorator'
import Loader from '@/components/misc/Loader.vue'
import EVMAddressSummary from '@/components/Address/EVMAddressSummary.vue'
import HTTPError from '@/components/misc/HTTPError.vue'
import { TransactionsGettersMixin } from '@/store/modules/transactions/transactions.mixins'
import { getMappingForType } from '@/store/modules/transactions/maps'
import EVMTransactions from '@/components/Transaction/EVMTransactions.vue'
import { ParsedEVMTx } from '@/store/modules/transactions/helpers/parseEVMTxs'
import { CURRENT_SUBNET, HAS_SUBNET } from '@/store/modules/network/network'

@Component({
    components: {
        Loader,
        EVMAddressSummary,
        EVMTransactions,
        HTTPError,
    },
    filters: {
        getType: getMappingForType,
    },
})
export default class EVMAddressPage extends Mixins(TransactionsGettersMixin) {
    loading = true
    startingTx = 0
    transactionsOffsets = [10, 25, 50]
    transactionsOffset = this.transactionsOffsets[0]
    mounted() {
        if (CURRENT_SUBNET !== null) {
            this.loading = false
        } else {
            this.updateTxs()
        }
        if (!this.address.startsWith('0x') || this.address.length !== 42) {
            this.$router.replace('/404')
        }
    }

    get hasSubnet() {
        return HAS_SUBNET
    }
    get subnetName() {
        return CURRENT_SUBNET
    }
    get address(): string {
        return this.$route.params.id
    }

    get filteredTransactions(): ParsedEVMTx[] {
        return this.evmTransactions.slice(
            this.startingTx,
            this.startingTx + this.transactionsOffset
        )
    }

    @Watch('startingTx')
    controlStartingTx() {
        this.startingTx = Math.min(
            this.startingTx,
            this.evmTransactions.length - 1
        )
        this.startingTx = Math.max(this.startingTx, 0)
    }

    nextPage() {
        this.startingTx = this.startingTx + this.transactionsOffset
    }

    previousPage() {
        this.startingTx -= this.transactionsOffset
    }

    get evmTransactions(): ParsedEVMTx[] {
        return this.getEVMTxs()
    }
    updateOffset(offset: number) {
        this.transactionsOffset = offset
    }

    async updateTxs() {
        this.loading = true
        await this.$root.$store
            .dispatch('Transactions/getEVMTxs', {
                params: {
                    sort: 'timestamp-desc',
                    address: this.address,
                },
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                this.loading = false
            })
    }
}
